// styles/base/components/navigation.js
/**
 * Navigation component overrides and variants
 * Because navigation should guide with authority, not merely suggest
 */

import { alpha, colors } from '../tokens';

export const navigationOverrides = {
    MuiAppBar: {
        variants: [
            {
                props: { variant: 'bootstrap' },
                style: {
                    boxShadow: 'none',
                    backgroundColor: colors.appBar,
                },
            },
        ],
    },

    MuiToolbar: {
        variants: [
            {
                props: { variant: 'bootstrap' },
                style: {
                    minHeight: '56px',
                    padding: 0,
                    '@media (min-width: 600px)': {
                        minHeight: '56px', // Consistent height across breakpoints
                    },
                },
            },
        ],
    },

    MuiContainer: {
        variants: [
            {
                props: { variant: 'bootstrap' },
                style: {
                    paddingLeft: '15px',
                    paddingRight: '15px',
                },
            },
        ],
    },

    MuiTabs: {
        variants: [
            {
                props: { variant: 'bootstrap' },
                style: {
                    '& .MuiTabs-indicator': {
                        display: 'none', // Clean tab design without underlines
                    },
                },
            },
        ],
    },

    MuiTab: {
        variants: [
            {
                props: { variant: 'bootstrap' },
                style: {
                    textTransform: 'none',
                    fontSize: '1rem',
                    '&.Mui-selected': {
                        textDecoration: 'underline', // Subtle selected state indication
                    },
                },
            },
        ],
    },

    MuiMenu: {
        variants: [
            {
                props: { variant: 'bootstrap' },
                style: {
                    '& .MuiPaper-root': {
                        boxShadow: '0 .5rem 1rem rgba(0,0,0,.15)',
                        borderRadius: '4px',
                    },
                },
            },
        ],
    },

    MuiMenuItem: {
        variants: [
            {
                props: { variant: 'bootstrap' },
                style: {
                    fontSize: '0.875rem',
                    padding: '8px 16px',
                    minHeight: 'auto',
                    '&:hover': {
                        backgroundColor: alpha(colors.text, 0.04),
                    },
                },
            },
        ],
    },
};
